import { Button, Col, DatePicker, Input, Row, Select, Space } from "antd";
import dayjs from 'dayjs';
import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { AddSvg, SearchSvg } from "utils/svgs";
import { checkPermission } from "utils/utils";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";
const { RangePicker } = DatePicker;

// For search filter and paginate
const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  // Init
  const {
    performSearchHandler,
    searchValue,
    openDrawerHandler,
    title,
    setSearch,
    allUsers,
    setSelectedUser,
    selectedUser,
    selectedDate,
    setSelectedDate,
    totalRecords,
    statusFilter,
    onStatusFilterChange,
    categoryFilter,
    onCategoryFilterChange,
    categories = [],
    saltCompositionFilter = '',
    onSaltCompositionFilterChange,
  } = props;

  const userPermissions = useSelector(
    (state: any) => state?.userProfile?.data
  );
  const isAddPermission = checkPermission(userPermissions?.permissions, {
    permissionName: 'Medicines',
    permission: ['add'],
  });

  const isMedicinesViewAll = checkPermission(userPermissions?.permissions, {
    permissionName: 'Medicines',
    permission: ['viewAll'],
  });

  const canViewAllUsers = userPermissions?.isAdmin || isMedicinesViewAll;
  /** Status and Category filters are for admin only */
  const showStatusCategoryFilters = userPermissions?.isAdmin === true;

  const activeUserOptions = useMemo(
    () =>
      (allUsers || [])
        .filter((item: any) => item?.status !== false)
        .map((item: any) => ({
          label: item?.name,
          value: item?.userId,
        })),
    [allUsers]
  );

  const inactiveUserOptions = useMemo(
    () =>
      (allUsers || [])
        .filter((item: any) => item?.status === false)
        .map((item: any) => ({
          label: item?.name,
          value: item?.userId,
        })),
    [allUsers]
  );

  // JSX
  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row justify={"space-between"}>
          <Col>
            <div className={styles["search-filter__wrapper--title"]}>
              {title}
              <span className={styles["search-filter__wrapper--title--count"]}>({totalRecords})</span>
            </div>
          </Col>
          <Col>
            <Space>
              <Button
                onClick={() => {
                  setSearch('');
                  onSaltCompositionFilterChange?.('');
                  if (canViewAllUsers) setSelectedUser(undefined);
                  if (showStatusCategoryFilters) {
                    onStatusFilterChange?.(null);
                    onCategoryFilterChange?.(null);
                  }
                  setSelectedDate(null);
                }}
              >
                Clear all
              </Button>

              <Input
                className={styles["search-filter__search"]}
                placeholder="Search by Product Name"
                prefix={<SearchSvg />}
                onChange={performSearchHandler}
                value={searchValue}
                size="large"
                allowClear
              />

              <Input
                placeholder="Salt Composition"
                size="large"
                style={{ width: 200 }}
                allowClear
                value={saltCompositionFilter}
                onChange={(e) => onSaltCompositionFilterChange?.(e.target.value)}
              />

              {showStatusCategoryFilters && (
                <>
                  <Select
                    value={statusFilter ?? undefined}
                    placeholder="Status"
                    size="large"
                    style={{ width: 140 }}
                    onChange={(value) => onStatusFilterChange?.(value ?? null)}
                    allowClear
                    options={[
                      { label: 'Pending', value: 'PENDING' },
                      { label: 'Rejected', value: 'REJECTED' },
                      { label: 'Approved', value: 'APPROVED' },
                    ]}
                  />
                  <Select
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toString()
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    value={categoryFilter ?? undefined}
                    placeholder="Category"
                    size="large"
                    style={{ width: 200 }}
                    onChange={(value) => onCategoryFilterChange?.(value ?? null)}
                    allowClear
                    options={categories.map((cat) => ({
                      label: cat.categoryName,
                      value: cat.id,
                    }))}
                  />
                </>
              )}
              {canViewAllUsers && (
                <>
                  <Select
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toString()
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    value={selectedUser}
                    placeholder="Select User"
                    size="large"
                    style={{ width: 200 }}
                    onChange={(value) => setSelectedUser(value)}
                    allowClear
                    options={
                      [
                        ...(activeUserOptions.length
                          ? [{ label: 'Active', options: activeUserOptions }]
                          : []),
                        ...(inactiveUserOptions.length
                          ? [{ label: 'Inactive', options: inactiveUserOptions }]
                          : []),
                      ]
                    }
                  />
                </>
              )}

              <RangePicker
                picker="date"
                format="DD/MM/YYYY"
                style={{ width: 120, height: 40 }}
                allowClear
                onChange={(value) => {
                  if (!value || !value[0] || !value[1]) {
                    setSelectedDate(null);
                  } else {
                    setSelectedDate([
                      dayjs(value[0]).startOf("day"),
                      dayjs(value[1]).endOf("day")
                    ]);
                  }
                }}
                value={selectedDate}
              />


              {/* {
                userPermissions?.roleName === 'Admin' &&
                <div className={`${styles['file-upload-container']} file-upload-container`}>
                  <Upload {...uploadProps}>
                    <Button icon={<UploadOutlined />} style={{ width: "50px", height: "39px" }} />
                  </Upload>
                </div>
              } */}

              <div className={styles['user-table__action']}>
                {isAddPermission && (
                  <button
                    className={`btn-blue ${styles['user-table__action--button']}`}
                    onClick={openDrawerHandler}
                  >
                    <AddSvg />
                    <p>Add Medicines</p>
                  </button>
                )}
              </div>
            </Space>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;
